var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrderFilters',{on:{"errorsOnlyChange":(val) => (_vm.showErrorsOnly = val),"dateChange":_vm.onDateChange}}),(!_vm.loading)?_c('div',[_c('OrdersStatistics',{attrs:{"orders":_vm.orders}}),_c('OrdersList',{attrs:{"orders":_vm.orders}})],1):_c('StateDisplay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }